import React from 'react'
import thunk from 'redux-thunk'
import ReactDOM from 'react-dom'
import { Route, Switch } from 'react-router'
import { Provider } from 'react-redux'
import { LocaleProvider } from 'antd'
import enUS from 'antd/lib/locale-provider/en_US'
import { createStore, applyMiddleware } from 'redux'
import createHistory from 'history/createBrowserHistory'
import { sessionService } from 'redux-react-session'
import { ConnectedRouter, routerMiddleware } from 'react-router-redux'

import { apiMiddleware } from 'redux-api-middleware'
import registerServiceWorker from './registerServiceWorker' // eslint-disable-line
import asyncComponent from "./components/AsyncComponent";

import asyncMiddleware from './middlewares/asyncMiddleware'
import loggerMiddleware from './middlewares/loggerMiddleware'
import Reducers from './reducers'


const _Header = asyncComponent(() => import('./containers/layouts/Header'))
const _Footer = asyncComponent(() => import('./containers/layouts/Footer'))
const _Chat = asyncComponent(() => import('./containers/layouts/Chat'))
const _Modal = asyncComponent(() => import('./containers/Modal'))
const Home = asyncComponent(() => import('./containers/pages/Home'))
const CourseDetail = asyncComponent(() => import('./containers/pages/CourseDetail'))
const MediaQuery = asyncComponent(() => import('./containers/MediaQuery'))
const Profile = asyncComponent(() => import('./containers/pages/Profile'))
const Search = asyncComponent(() => import('./containers/pages/Search'))
const Signup = asyncComponent(() => import('./containers/pages/Signup'))
const ResetPassword = asyncComponent(() => import('./containers/pages/ResetPassword'))
// const AsyncHome = asyncComponent(() => import('./containers/pages/SignupInstructor'))
// const AsyncHome = asyncComponent(() => import('./containers/pages/Signin'))
const Setting = asyncComponent(() => import('./containers/pages/Setting'))
const LibraryCourse = asyncComponent(() => import('./containers/pages/LibraryCourse'))
const LibraryExam = asyncComponent(() => import('./containers/pages/LibraryExam'))
const Following = asyncComponent(() => import('./containers/pages/Following'))
const Interest = asyncComponent(() => import('./containers/pages/Interest'))
const WishList = asyncComponent(() => import('./containers/pages/WishList'))
const Playlist = asyncComponent(() => import('./containers/pages/Playlist'))
const ScrollTop = asyncComponent(() => import('./containers/ScrollTop'))
const Privacy = asyncComponent(() => import('./containers/pages/Privacy'))
const Policy = asyncComponent(() => import('./containers/pages/Policy'))
const TermOfUse = asyncComponent(() => import('./containers/pages/TermOfUse'))
const howtoPay = asyncComponent(() => import('./components/pages/howToPay'))
const VideoPlayer = asyncComponent(() => import('./containers/pages/JWVideoPlayer'))
const LineStudentRegister = asyncComponent(() => import('./components/LineStudentRegister/LineStudentRegister-container'))
const SuccessLineRegister = asyncComponent(() => import('./components/LineStudentRegister/SuccessLineRegister'))
const LineFormDetail = asyncComponent(() => import('./components/LineFormDetail/LineFormDetail-container'))
const SuccesslinePayment = asyncComponent(() => import('./components/LineFormDetail/successPayment'))
// const Verify = asyncComponent(() => import('./containers/pages/Verify'))
// const Instructor = asyncComponent(() => import('./containers/pages/Instructor'))
// const InstructorHome = asyncComponent(() => import('./containers/pages/InstructorHome'))
// const InstructorNewCourse = asyncComponent(() => import('./containers/pages/InstructorNewCourse'))
// const InstructorNewCourseTest = asyncComponent(() => import('./containers/pages/InstructorNewCourseTest'))
const ReviewVerify = asyncComponent(() => import('./containers/pages/ReviewVerify'))
// const Creators = asyncComponent(() => import('./containers/pages/Creators'))
// const CourseEdit = asyncComponent(() => import('./containers/pages/CourseEdit'))
// const ContactStaff = asyncComponent(() => import('./containers/pages/ContactStaff'))
// const CourseOneByOne = asyncComponent(() => import('./containers/pages/CourseOneByOne'))
const ETestingHome = asyncComponent(() => import('./containers/pages/ETestingHome'))
const ETestingExample = asyncComponent(() => import('./containers/pages/ETestingExample'))
// const AsyncHome = asyncComponent(() => import('./containers/pages/ETestingSection'))
// const AsyncHome = asyncComponent(() => import('./containers/pages/ETestingList'))
const ETestingOverview = asyncComponent(() => import('./containers/pages/ETestingOverview'))
const ETestingReviewResult = asyncComponent(() => import('./containers/pages/ETestingReviewResult'))
const ETestingAnswer = asyncComponent(() => import('./containers/pages/ETestingAnswer'))
// const AsyncHome = asyncComponent(() => import('./containers/pages/Live'))
//mobile
const ETestingExampleMobile = asyncComponent(() => import('./containers/pages/ETestingExampleMobile'))
const ETestingOverviewMobile = asyncComponent(() => import('./containers/pages/ETestingOverviewMobile'))
const QuizOverviewMobile = asyncComponent(() => import('./containers/pages/QuizOverviewMobile'))
const ETestingReviewResultMobile = asyncComponent(() => import('./containers/pages/ETestingReviewResultMobile'))
const ETestingAnswerMobile = asyncComponent(() => import('./containers/pages/ETestingAnswerMobile'))


const QuizOverview = asyncComponent(() => import('./containers/pages/QuizOverview'))


const InstructorRegister = asyncComponent(() => import('./containers/pages/InstructorRegister'))
const tutorRegister = asyncComponent(() => import('./components/tutorRegister/tutorRegister-container'))
const TestLoginFacebookMb = asyncComponent(() => import('./containers/pages/TestLoginFacebookMb'))
const Coin = asyncComponent(() => import('./containers/pages/CoinStore'))
const SuccessPayment = asyncComponent(() => import('./containers/pages/SuccessPaymentStore'))
const TestExam = asyncComponent(() => import('./containers/pages/TestExamStore'))
const PackageDetail = asyncComponent(() => import('./containers/pages/PackageDetail'))

// const NotFound = asyncComponent(() => import('./containers/pages/NotFound'))
const NotFoundImg = asyncComponent(() => import('./containers/pages/NotFound_Img'))
// const AcceptMerge = asyncComponent(() => import('./containers/pages/AcceptMerge'))
// const SigninMerge = asyncComponent(() => import('./containers/pages/SigninMerge'))
// const SuccessMerge = asyncComponent(() => import('./containers/pages/SuccessMerge'))
const NewLogin = asyncComponent(() => import('./containers/pages/NewLogin'))
const Guest = asyncComponent(() => import('./containers/pages/Guest'))
const ETestingHistory = asyncComponent(() => import('./containers/pages/ETestingHistory'))
const ETestingHistoryDetail = asyncComponent(() => import('./containers/pages/ETestingHistoryDetail'))
const LiveDetail = asyncComponent(() => import('./containers/pages/LiveDetail'))
const Live = asyncComponent(() => import('./containers/pages/Live'))

// const AsyncHome = asyncComponent(() => import('./containers/UploadCourse'))
const Calendar = asyncComponent(() => import('./containers/pages/Calendar'))
const Lesson = asyncComponent(() => import('./containers/pages/Lesson'))
const PdfReader = asyncComponent(() => import('./containers/pages/PdfReader'))
// const NavigationCourse = asyncComponent(() => import('./containers/pages/NavigationCourse'))

import { decodeQueryUrl } from './utils'

import 'antd/dist/antd.css' // eslint-disable-line import/first
import './App.css'          // eslint-disable-line import/first
// import './theme/css/main_login.css'
import './theme/css/font-awesome.css'
import './theme/css/material-design-iconic-font.css'
import './theme/fi/flaticon.css'
import './theme/css/main1.css'
import './theme/css/jquery.fancybox.css'
import './theme/css/owl.carousel.css'
import './theme/rs-plugin/css/settings.css'
import './theme/css/animate.css'
import BannerProduct from './containers/pages/BannerProduct';
import reviewVerify from './components/tutorRegister/reviewVerify';

const history = createHistory()
const middleware = routerMiddleware(history)
const store = createStore(
  Reducers,
  process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() : {},
  applyMiddleware(
    asyncMiddleware,
    apiMiddleware,
    loggerMiddleware,
    middleware,
    thunk,
  ),
)

sessionService.initSessionService(store, { driver: 'COOKIES' })

if (process.env.NODE_ENV === 'development') console.log(process.env)

// const redirect = (state) => {
//   const redirectUrl = decodeQueryUrl(state.location.search).url
//   window.location = redirectUrl
//   this.forceUpdate()
//   return (
//     <div />
//   )
// }
const Root = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <LocaleProvider locale={enUS}>
        <div>
          <MediaQuery />
          <Switch>
            {/* <Route exact path="/" component={NotFound} /> */}
            {/* <Route exact path="/" component={NotFoundImg} /> */}
            <Route path="/notFoundImg" component={NotFoundImg} />
            {/* <Route exact path="/newLogin" component={NewLogin} /> */}
            {/* <Route path="/course/:slugName/:section/:lecture" component={Playlist} /> */}
            {/* <Route path="/redirect" component={redirect} /> */}
            <Route exact path="/signin" component={NewLogin} />
            <Route exact path="/resetPassword" component={ResetPassword} />
            <Route exact path="/guest" component={Guest} />
            <Route exact path="/coin" component={Coin} />
            <Route exact path="/successPayment" component={SuccessPayment} />
            {/* <Route exact path="/instructor/verify" component={Verify} /> */}
            <Route exact path="/instructor/review" component={ReviewVerify} />
            {/* <Route exact path="/instructor/signup" component={SignupInstructor} /> */}
            {/* <Route path="/redirect" render={() => (<Redirect to="/dashboard" />)} /> */}
            <Route exact path="/privacy" component={Privacy} />
            <Route exact path="/policy" component={Policy} />
            <Route exact path="/termOfUse" component={TermOfUse} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/lineStudentRegister/:slugName" component={LineStudentRegister} />
            <Route exact path="/lineStudentRegister/:slugName/success" component={SuccessLineRegister} />
            <Route exact path="/LineFormDetail/:serviceId/:tutorId" component={LineFormDetail} />
            <Route exact path="/LineFormDetail/:serviceId/:tutorId/success" component={SuccesslinePayment} />
            <Route exact path="/instructorRegister" component={InstructorRegister} />
            <Route exact path="/tutorRegister/:slugName" component={tutorRegister} />
            <Route exact path="/tutorRegister/:slugName/success" component={reviewVerify} />
            {/* <Route component={NotFoundImg} /> */}
            {/* <Route exact path="/eTestingExample/:slugName" component={ETestingExample} /> */}
            {/* <Route component={NotFoundImg} /> */}
            {/* <Route exact path="/lesson/:slugName" component={Lesson} /> */}

            {/* Mobile */}
            {/* <div> */}
              <Route exact path="/quizOverviewMobile/:slugName/:slugNameExam" component={QuizOverviewMobile} />
              <Route exact path="/eTestingReviewResultMobile/:slugName/:slugNameExam" component={ETestingReviewResultMobile} />
              <Route exact path="/lesson/:slugName" component={Lesson} />
              {/* <Route path="/(quizOverviewMobile|lesson|eTestingReviewResultMobile)/:slugName" component={NavigationCourse} /> */}
            {/* </div> */}
            <Route exact path="/eTestingExampleMobile/:slugName/:slugNameExam" component={ETestingExampleMobile} />
            {/* <Route exact path="/eTestingList/:slugName" component={ETestingList} /> */}
            <Route exact path="/eTestingOverviewMobile/:slugName/:slugNameExam" component={ETestingOverviewMobile} />
            {/* <Route exact path="/quizOverviewMobile/:slugName/:slugNameExam" component={QuizOverviewMobile} /> */}
            {/* <Route exact path="/eTestingReviewResultMobile/:slugName/:slugNameExam" component={ETestingReviewResultMobile} /> */}
            <Route exact path="/eTestingAnswerMobile/:slugName/:slugNameExam" component={ETestingAnswerMobile} />
            <Route exact path="/VideoPlayer" component={VideoPlayer} />
            <Route exact path="/PdfReader" component={PdfReader} />

            <div>
              <_Header />
              <div id="outer-container">
                <div className="content-inner" id="page-wrap">
                  <Route exact path="/" component={ETestingHome} />
                  <Route exact path="/home" component={ETestingHome} />
                  {/* <Route exact path="/course" component={Home} /> */}
                  <Route exact path="/howtopay" component={howtoPay} />
                  <Route exact path="/packageDetail/:slugName" component={PackageDetail} />
                  <Route exact path="/testExam/:slugName/:codeCoupon" component={TestExam} />
                  <Route exact path="/testExam/:slugName/" component={TestExam} />
                  {/* <Route exact path="/" component={function () { window.location.href = '/instructorRegister' }} /> */}
                  {/* <Route path="/course/:slugName" component={CourseDetail} /> */}
                  {/* <Route path="/course/:slugName" component={CourseDetail} /> */}
                  <Route exact path="/profile/:slugName" component={Profile} />
                  <Route path="/search/:keyword" component={Search} />
                  {/* <Route exact path="/signup" component={Signup} /> */}
                  {/* <Route exact path="/signin" component={Signin} /> */}
                  <Route exact path="/setting" component={Setting} />
                  <Route exact path="/library/course" component={LibraryCourse} />
                  <Route exact path="/library/exam" component={LibraryExam} />
                  <Route exact path="/following" component={Following} />
                  <Route exact path="/interest" component={Interest} />
                  <Route exact path="/wishlist" component={WishList} />

                  <Route exact path="/quizOverview/:slugName/:slugNameExam" component={QuizOverview} />
                  
                  {/* <Route exact path="/creators" component={Creators} /> */}
                  <Route exact path="/privacy" component={Privacy} />
                  <Route exact path="/calendar" component={Calendar} />
                  {/* <Route exact path="/instructor" component={InstructorHome} />
                  <Route exact path="/instructor/dashboard" component={Instructor} />
                  <Route exact path="/instructor/signup" component={SignupInstructor} />
                  <Route exact path="/instructor/verify" component={Verify} />
                  <Route exact path="/instructor/review" component={ReviewVerify} />
                  <Route exact path="/instructor/create" component={InstructorNewCourse} />
                  <Route exact path="/instructor/createCourse" component={InstructorNewCourseTest} />
                  <Route strict path="/instructor/:slugName/" component={CourseEdit} />
                  <Route exact path="/contactstaff/:slugName" component={ContactStaff} />
                  <Route exact path="/courseOneByOne" component={CourseOneByOne} /> */}

                  {/* Web */}
                  <Route exact path="/eTestingHome" component={ETestingHome} />
                  {/* <Route exact path="/eTestingSection/:slugName" component={ETestingSection} /> */}
                  <Route exact path="/eTestingExample/:slugName" component={ETestingExample} />
                  {/* <Route exact path="/eTestingList/:slugName" component={ETestingList} /> */}
                  <Route exact path="/eTestingOverview/:slugName" component={ETestingOverview} />
                  <Route exact path="/eTestingReviewResult/:slugName" component={ETestingReviewResult} />
                  <Route exact path="/eTestingAnswer/:slugName" component={ETestingAnswer} />

                  {/* <Route exact path="/live" component={Live} /> */}
                  {/* <Route exact path="/instructorRegister" component={InstructorRegister} /> */}
                  <Route exact path="/testLoginFacebookMb" component={TestLoginFacebookMb} />
                  <Route exact path="/banner/:slugName" component={BannerProduct} />
                  {/* <Route exact path="/acceptMerge" component={AcceptMerge} /> */}
                  {/* <Route exact path="/signInMerge" component={SigninMerge} /> */}
                  {/* <Route exact path="/successMerge" component={SuccessMerge} /> */}
                  <Route exact path="/eTestingHistory" component={ETestingHistory} />
                  <Route exact path="/eTestingHistoryDetail/:slugName" component={ETestingHistoryDetail} />
                  <Route exact path="/live/:slugName/:slugNameLive" component={LiveDetail} />
                  <Route exact path="/live" component={Live} />
                  {/* <Route exact path="/eTestingHome" component={ETestingHome} />
                {/* <Route exact path="/eTestingSection/:slugName" component={ETestingSection} /> */}
                  {/* <Route exact path="/eTestingOverview/:slugName" component={ETestingOverview} /> */}
                  {/* <Route exact path="/eTestingExample/:slugName" component={ETestingExample} /> */}
                  {/* </div> */}
                  <ScrollTop />
                </div>
              </div>
              <_Footer />
              <_Modal />
              {/* <UploadCourse /> */}
            </div>
            <Route component={NotFoundImg} />
          </Switch>
          {/* <Route exact path="/live/:slugName" component={_Chat} /> */}
        </div>
      </LocaleProvider>
    </ConnectedRouter>
  </Provider>
)

ReactDOM.render(<Root />, document.getElementById('root'))

registerServiceWorker() // eslint-disable-line



// WEBPACK FOOTER //
// ./src/index.js